import { render } from "./BroodmaresPage.vue?vue&type=template&id=7cfa18c1&scoped=true"
import script from "./BroodmaresPage.vue?vue&type=script&lang=js"
export * from "./BroodmaresPage.vue?vue&type=script&lang=js"

import "./BroodmaresPage.vue?vue&type=style&index=0&id=7cfa18c1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfa18c1"]])

export default __exports__